import React from 'react';
import cx from 'classnames';
import { Modal, ProgressBar } from 'react-bootstrap';
import styles from './chunkProgressModal.module.scss';

export const ChunkProgressModal = ({ show, currentChunk, totalChunks, onClose }) => {
  const progress = ((currentChunk / totalChunks) * 100).toFixed(0);
  const remaining = totalChunks - currentChunk;

  return (
    <Modal
      backdrop="static"
      keyboard={false}
      className={styles.chunkModal}
      show={show}
      centered
      size="sm"
    >
      <button className={styles.closeButton} onClick={onClose}>
        <i className={cx('cleverstory-close', styles.closeButtonIcon)} />
      </button>
      <Modal.Body className={styles.chunkModalBody}>
        <div className={styles.iconWrapper}>
          <i className="cleverstory-copy" />
        </div>
        
        <h3 className={styles.title}>
          {remaining > 0 ? 'Importing Figma Design...' : 'Processing...'}
        </h3>
        
        <p className={styles.description}>
          {remaining > 0 
            ? `Part ${currentChunk} of ${totalChunks} received`
            : 'Preparing your design...'
          }
        </p>

        <ProgressBar 
          now={progress} 
          className={styles.progressBar}
          animated={remaining > 0}
        />

        {remaining > 0 && (
          <div className={styles.instructions}>
            <p className={styles.instructionsText}>
              Please copy and paste <strong>Part {currentChunk + 1}</strong> from Figma plugin
            </p>
            <div className={styles.remainingChunks}>
              {remaining === 1 ? '1 part remaining' : `${remaining} parts remaining`}
            </div>
          </div>
        )}

        {remaining === 0 && (
          <div className={styles.processingText}>
            Extracting fonts and preparing elements...
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};